import { render, staticRenderFns } from "./flightWizard.vue?vue&type=template&id=f2b1d966&scoped=true&"
import script from "./flightWizard.vue?vue&type=script&lang=ts&"
export * from "./flightWizard.vue?vue&type=script&lang=ts&"
import style1 from "./flightWizard.vue?vue&type=style&index=1&id=f2b1d966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b1d966",
  null
  
)

export default component.exports